import CustomizeInfo from "./customizeInfo";
import { config } from "../utils/config";
import { LineItemType } from "../enums/lineItemType";
import { ShipmentType} from "../enums/ShipmentType"

export default class Lineitem {
    private prope65Attribute: string = 'Prop_65_Warning___LOV';
    private hazardousAttribute: string = 'Hazardous_Material___LOV';
    private shipmentTypeAttribute: string = 'Ship_Category___LOV';
    private imageLocale: string = config('localesWithoutImages').includes(config('locale')) && config('fallbackLocaleForNoImages');

    id: string;
    type: string;
    mode: string;
    name: string;
    productType: string;
    quantity: string;
    totalPriceWithoutAnyCharges: number;
    unitPriceFormappingWithGlobalAndUserDiscount: any;
    isProp65Warning: boolean = false;
    isLineItemHazardous: boolean = false;
    productImageUrl: string;
    imprintImageUrl: string;
    productId: string;
    productFamilyName: string;
    webCode: string;
    customizationType: string;
    productDiscountCode: string;
    itemLogoCharge: number;
    itemLogoDiscount: number;
    itemLogoChargeWithGlobalDiscount:any;
    logoImprintAdded: boolean = false;
    isLogoFree: boolean;
    baseLogoCharge: number;
    isSetUpChargeFree: boolean;
    logoChargeApplicable: boolean;
    unitPrice: number;
    actualUnitPrice: number;
    totalItemPriceWithLogo: number;
    totalItemPriceWithLogoWithoutDiscount: number;
    totalDiscountWithLogo: number;
    setupChargeAdded: boolean = false;
    lineItemSetupCharge: number;
    lineItemSetupDiscount: number;
    itemSetupChargeWithGlobalDiscount: any;
    
    totalDiscount: number;
    totalDiscountWithSubItem: number;
    taxRate: number;
    taxRateWithName: any;
    productVariantSku: string;
    productAttributes: any;
    categoryName: string;
    productKey: string;
    idpFromDate: string = ''; //Date
    idpToDate: string = ''; //Date
    mcpSku: string;
    multiSelectData: any = {};
    customLineItems: any = [];
    customizationInfo: any;
    digitalPrintProofRequired: boolean;
    specialInstructionsForLineItem: any;
    variableAttributes: any;
    productSpecification: any;
    externalTaxRateDraft: any = {};
    externalPrice: any;
    shippingCategory: string;
    customfield: any;
    totalQuantityWithSubItem: number;
    totalPriceWithSubItem: number;
    totalBasePriceWithSubItem: number;
    userSelection: Array<any>;
    apparelSortedSizes: Array<any>;
    variantId: string;
    variantSku: string;
    productSlug: string;
    effectivePrice: any;
    isShipmentTypeHeavy: boolean = false;
    isV2Product: boolean = false;
    merchantProductVersion: string;
    isImprintOverflow: boolean = false;
    productionTime: string;
    shipCategory: string;
    postCheckOutCustomization: boolean = false;
    totalPriceWithSubItemPriceModal: number;
    isOutOfStock: boolean = false;
    itemImportCharge: number;
    isBelowMOQ: boolean = false;

    constructor(lineitem: any) {
        
        /* sorted */
        this.id = lineitem.id;
        this.effectivePrice = lineitem.effectivePrice;
        this.productId = lineitem.productId;
        this.productKey = lineitem.productKey
        this.productFamilyName = lineitem.custom.fields.productFamilyName ?? ''
        this.webCode = lineitem.custom.fields.webCode ?? ''
        this.categoryName = lineitem.custom.fields.categoryName ?? ''
        this.productType = (lineitem.custom.fields.productFamilyName.slice(0,3) === 'VEN' || lineitem.custom.fields.productFamilyName.slice(0,3) === 'VDS') ? 'vendor' : 'inhouse'
        this.mcpSku = lineitem.custom.fields.mcpSku ?? ''
        this.productVariantSku = lineitem.variant?.sku ?? ''       
        this.customLineItems = lineitem?.customLineItems ?? [];
        this.customizationInfo = JSON.parse(lineitem.custom.fields.customizationInfo ?? '{}')
        this.digitalPrintProofRequired = lineitem?.custom?.fields?.digitalPrintProofRequired ?? ''
        this.specialInstructionsForLineItem = lineitem?.custom?.fields?.specialInstructionsForLineItem ?? ''
        this.postCheckOutCustomization = lineitem?.custom?.fields?.postCheckOutCustomization ?? false;
        this.variableAttributes = lineitem.custom.fields.variableAttributes ?? '{}'
        this.productSpecification = JSON.parse(lineitem.custom.fields.productSpecification ?? '{}')
        this.type = lineitem.custom?.fields?.lineItemType.toLowerCase() ?? '';
        this.mode = lineitem.lineItemMode;
        this.quantity = lineitem.quantity
        this.totalPriceWithoutAnyCharges = lineitem.effectivePrice?.originalPrice?.mainItem ?? 0;
        this.unitPrice = lineitem.price.value.centAmount ?? 0; 
        this.actualUnitPrice = lineitem.effectivePrice.actualPrice.mainItemUnitPrice??0;
        this.isV2Product = lineitem?.custom?.fields?.isV2Product ?? false;
        this.merchantProductVersion = lineitem?.custom?.fields?.merchantProductVersion ?? '';
        const nameValue = this.isV2Product ? lineitem?.custom?.fields?.merchandisingProductName : lineitem?.name?.[config('locale')];
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.lineItemSetupCharge = lineitem.effectivePrice?.basePrice?.setupItem ?? 0
        this.lineItemSetupDiscount = lineitem.effectivePrice?.discount?.setupItem ?? 0;
        this.isSetUpChargeFree = lineitem.effectivePrice?.originalPrice?.setupItem > 0 && lineitem.effectivePrice?.originalPrice?.setupItem === lineitem.effectivePrice?.discount?.setupItem
        this.setupChargeAdded = this.customLineItems?.some(({custom: {fields}}) => fields.customLineItemType === 'setupcharge') ?? false;
        this.itemSetupChargeWithGlobalDiscount = (lineitem.effectivePrice?.publicDiscount?.setupItem === this.lineItemSetupCharge) && (this.lineItemSetupCharge > 0) ? 'Free' : (lineitem.effectivePrice?.originalPrice?.setupItem ?? 0);
        this.itemImportCharge = lineitem.effectivePrice?.originalPrice?.importItem ?? 0;
        this.isBelowMOQ = lineitem?.custom?.fields?.isBelowMOQ ? true : false;
        this.logoImprintAdded = this.customLineItems?.some(({custom: {fields}}) => fields.customLineItemType === 'logocharge') ?? false;
        this.customfield = lineitem?.custom?.fields;

        this.itemLogoCharge = lineitem.effectivePrice?.basePrice?.logoItem ?? 0;
        this.itemLogoDiscount = Number(lineitem.effectivePrice?.discount?.logoItem ?? 0);
        this.isLogoFree = lineitem.effectivePrice?.discount?.logoItem > 0 && lineitem.effectivePrice?.originalPrice?.logoItem === lineitem.effectivePrice?.discount?.logoItem
        this.baseLogoCharge = lineitem.variant.prices?.[0]?.custom?.fields?.LogoCharge ?? 0
        this.logoChargeApplicable = lineitem.custom.fields.logoChargeApplicable ?? false;
        this.totalItemPriceWithLogo = lineitem.effectivePrice.actualPrice?.subtotalwithlogo ?? 0
        this.totalItemPriceWithLogoWithoutDiscount = lineitem.effectivePrice.basePrice?.subtotalwithlogo ?? 0
        this.totalDiscountWithLogo = lineitem.effectivePrice.discount?.subtotalwithlogo ?? 0
        this.itemLogoChargeWithGlobalDiscount = (lineitem.effectivePrice?.publicDiscount?.logoItem === this.itemLogoCharge) && (this.itemLogoCharge > 0) ? 'free' : (lineitem.effectivePrice?.originalPrice?.logoItem ?? 0);
        this.unitPriceFormappingWithGlobalAndUserDiscount = lineitem.effectivePrice.originalPrice.mainItemUnitPrice;

        this.productSpecification?.attributes?.forEach(({name,value}) =>{
            if(name === this.prope65Attribute && value[0].key === 'Yes') this.isProp65Warning = true
            if(name === this.hazardousAttribute && value[0].key === 'Yes') this.isLineItemHazardous = true
            this.isShipmentTypeHeavy = name === this.shipmentTypeAttribute && value[0].key === ShipmentType.HEAVY;
        });

        if(this.isV2Product) {
            this.productImageUrl = lineitem?.custom?.fields?.productImageURL || config('DEFAULT_IMAGE_URL') || '';
        } else {
            this.productImageUrl = lineitem.variant.images?.find((image) => image.label?.includes(this.imageLocale))?.url
            ?? lineitem.variant?.images?.find((image) => image.url)?.url
            ?? lineitem.variant?.assets[0]?.tags.find((tag) => tag.includes('filename')) //get image from tags field in assests field in the variants
            ?? lineitem.variant?.assets[0]?.custom?.fields?.imageUrl //get image from custom fields in assests field in the variants
            ?? lineitem.variant?.defaultImages?.find((image) => image.label?.includes(this.imageLocale))?.url //get image from defaultImages field in variants
            ?? lineitem.variant?.defaultImages?.find((image) => image.url).url //get image from defaultImages field in variants
            ?? config('DEFAULT_IMAGE_URL')
            ?? '';
        }

        this.imprintImageUrl = lineitem.custom.fields.previewImageUrl ?? ''
        this.totalDiscount = lineitem.effectivePrice.discount?.mainItem ?? 0
        this.totalDiscountWithSubItem = lineitem.effectivePrice.discount?.mainItemWithSubItemTotal ?? 0
        this.productDiscountCode = lineitem.custom.fields.productDiscountCode ?? ''
        this.taxRate = this.type === LineItemType.MAINITEM ? lineitem.taxRate.amount : 0
        this.taxRateWithName = lineitem.taxRate
        this.customizationType = lineitem.custom.fields.customizationType
        this.productAttributes = new CustomizeInfo(this.productSpecification, this.customizationInfo, this.customizationType, this.variableAttributes);
        (this.type === LineItemType.MAINITEM || this.type === LineItemType.SUBITEM) && this.getMultiSelectAttributes(this.productAttributes.userSelectionInfo)        
        this.externalTaxRateDraft = JSON.parse(lineitem.custom.fields?.externalTaxRateDraft ?? '{}') 
        this.externalPrice = lineitem.price?.value ?? {}
        this.shippingCategory = this.getShippingCategory(lineitem.variant.prices, config('country'));
        this.totalQuantityWithSubItem = lineitem.totalQuantityWithSubItem ?? 0;
        this.totalPriceWithSubItem = lineitem.effectivePrice.originalPrice.mainItemWithSubItemTotal ?? 0;
        this.totalBasePriceWithSubItem = lineitem.effectivePrice.basePrice.mainItemWithSubItemTotal ?? 0;
        this.userSelection = lineitem.custom?.fields?.userSelection ?? []
        this.variantId = lineitem.variant.id
        this.variantSku = lineitem.variant.sku
        this.productSlug = lineitem.productSlug
        this.apparelSortedSizes = this.productSpecification?.selectableAttributes?.find(attr => attr.originalAttributeKey === "Size" || attr.originalAttributeKey === "Product Size")?.attributeValues?.map(attributeValue => attributeValue.value) || [];       
        this.isImprintOverflow = this.customizationInfo?.isImprintOverflow || false;
        this.productionTime = lineitem.custom.fields?.productionTime;
        this.shipCategory = lineitem?.custom?.fields?.shipCategory || ShipmentType.LIGHT;
        this.totalPriceWithSubItemPriceModal = lineitem.totalPriceWithSubItem ?? 0;
        this.isOutOfStock = lineitem?.custom?.fields?.isOutOfStock ?? false;
    }

    
    private getMultiSelectAttributes(userSelectionInfo){
        userSelectionInfo.forEach((userSelection)=>{
            if (userSelection?.renderType === config('MULTI_SELECT_USER_INPUT') && userSelection?.attribute) {
                this.multiSelectData.value = userSelection.value;
                this.multiSelectData.isExist = true; 
                this.multiSelectData.editData = userSelection
                let editData = {};

                userSelection.attributeValues?.forEach((attrVal) =>{
                    if (attrVal.originalValue) {
                        editData[attrVal.originalValue] = {
                            qty: 0,
                            attributeValue: attrVal.value,
                            lineItemId: null,
                            originalAttributeValue: attrVal.originalValue
                        };
                    }
                })
                editData[userSelection.originalAttributeValue] = {
                    qty : this.quantity,
                    attributeValue : userSelection.value,
                    lineItemId : this.id,
                    originalAttributeValue : userSelection.originalAttributeValue,
                    isMainItem : (this.type).toLowerCase() === LineItemType.MAINITEM,
                    arrCustomLineItem : this.customLineItems
                }
                this.multiSelectData.editData.attributeValues = editData
            }
        })
    }

    private getShippingCategory = (arrPrices, regionCode) => {
        const arrPrice = arrPrices.filter((obj) =>{
            if (obj.country.toUpperCase() === regionCode) {
                return true;
            } 
            else if (obj.custom?.fields?.locale?.toUpperCase().indexOf(regionCode) > -1) {
                return true;
            }            
            return false;
        });

        if (arrPrice.length > 0) {
            return arrPrice[0].custom.fields?.ShippingCategory ?? '';
        } else {
            return null;
        }
    };

    public setIdpDate(idpProductMap){
        this.idpFromDate = idpProductMap[this.productId +'_'+ this.mcpSku]?.fromDate ?? ''
        this.idpToDate = idpProductMap[this.productId +'_'+ this.mcpSku]?.toDate ?? ''
    }
}


/*
Currently in our app, we have mapped price data to total price Object in Recalculate API
Although data appears proper, but this thing needs to get confirmed from commerce squad

Other thing, all upsell related properties in this model are mapped based on the idea
that upsell is added and will be available in response api object

Same goes with free

*/